import apiClient, { authClient, refreshAccessToken } from '../api/apiClient';
import { tokenService } from './tokenService';

export const authApi = {
  async ensureCsrfCookie() {
    await authClient.get('/api/token/csrf/');
  },

  async login({ username, password }) {
    const response = await authClient.post('/api/token/', { username, password });
    return response.data;
  },

  async refresh() {
    const access = await refreshAccessToken();
    return { access };
  },

  async logout() {
    await authClient.post('/api/token/logout/', {});
  },

  async changePassword({ current_password, new_password, confirm_new_password }) {
    const generation = tokenService.getSessionGeneration();
    await authApi.ensureCsrfCookie();
    await apiClient.post('/api/me/password/', {
      current_password,
      new_password,
      confirm_new_password,
    }, { _authGeneration: generation });
    return generation;
  },

  async getCurrentUser() {
    const response = await apiClient.get('/api/me/');
    return response.data;
  },
};
